import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import useNavModel from "../model/navModel";
import useGlobalModel from "../model/globalModel";
import { forFind } from "../utils/utils";
import menuData from "../data/menuData.json";
import { Layout, Spin } from "antd";
import VrmMenu from "./VrmMenu";
import VrmHeader from "./VrmHeader";
import VrmNav from "./VrmNav";
import VrmRoute from "./VrmRoute";
import { useDictModel } from "../views/base/dict/dictModel"
import { useCustomerModel } from "@/views/base/customerFiles/customer/baseCustomerModel";
import { useSupplierModel } from "@/views/base/supplier/supplierModel";
import { useWarehouseModel } from "@/views/base/warehouse/warehouseModel";
import { useOrgModel } from "@/views/organization/org/orgModel";
import { useTechnicianModel } from "@/views/base/technician/technicianModel";
import logo1 from "@/assets/images/logo.jpg"
import { HomeOutlined } from "@ant-design/icons";
import ChangePass from "./ChangePass";

const { Sider, Content } = Layout;

const Index = () => {

    const history = useHistory();
    const { user, shopAndOrg, cm, loadingInfo: { loadingVisible, txt }, requestCatchAll } = useGlobalModel();
    const { addNav } = useNavModel();
    const { loadData: loadDictData } = useDictModel()
    const { loadData: orgLoadData } = useOrgModel();
    useEffect(() => {
        // 这里加载初始全局用到的数据
        if (shopAndOrg.shopId) {
            requestCatchAll(shopAndOrg.shopId)
            loadDictData(shopAndOrg.shopCode);
            orgLoadData();
            // beLoadDataAll();
            // appLoadDataAll();
            // loadCustomerAllData(shopAndOrg);
            // loadSupplierAllData(shopAndOrg);
            // loadWarehouseAllData(shopAndOrg);
            // loadTechnician(shopAndOrg);
        }
    }, [shopAndOrg])
    //监听在地址栏输入url。
    useEffect(() => {
        history.listen((location, action) => {
            if (action === "POP" && location.pathname !== "/login" && user.token) {
                // console.log(location)
                let findNav = forFind(menuData, location.pathname, "path", true);
                // console.log(location, action, "监听路有变化", findNav)
                addNav(findNav ? findNav.id : "404");
            }
        });
        // eslint-disable-next-line
    }, []);

    return (
        <Layout style={{ height: "100vh" }}>
            <Layout>
                <Sider className="layout-sider menu-box" trigger={null} collapsible collapsed={cm.collapsed} width={208}>
                    {/* <div className="layout-sider-shop">{user.shopName}1</div> */}
                    <div className="layout-sider-top">
                        <img src={logo1} />
                        <span>蜘蛛网车服</span>
                    </div>
                    {/* <div className="layout-sider-secondTop">
                        <HomeOutlined style={{ marginRight: '10px', marginTop: '3px', fontWeight: 'bolder' }} />
                        <div style={{ width: '69%' }}>
                            <span style={{ color: '#fff', fontWeight: 'bolder' }}>{shopAndOrg.shopName}</span>
                            <span style={{ fontSize: '12px', marginTop: '3px', float: 'right' }}>-- {user.userName}</span>
                        </div>
                    </div> */}
                    <VrmMenu />
                </Sider>
                <Layout className="layout-section">
                    <VrmHeader />
                    <VrmNav />
                    <Spin tip={txt} spinning={loadingVisible}>
                        <Content>
                            <div className="layout-section-content">
                                <VrmRoute />
                            </div>
                        </Content>
                    </Spin>
                </Layout>
                <ChangePass />
            </Layout>
        </Layout>
    )
}

export default Index;